<script setup lang="ts">
const { init, destroy } = useSmoothScroll()

onMounted(() => init())
onBeforeUnmount(() => destroy())
</script>

<template>
  <UApp>
    <!-- Vercel-Motiv: vertikale Rails in Shell-Breite über die volle Höhe -->
    <div class="page-rails" aria-hidden="true" />
    <div class="relative z-[1]">
      <SiteNav />
      <NuxtPage />
      <SiteFooter />
    </div>
  </UApp>
</template>
